import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Button from "@material-ui/core/Button";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteIcon from "@material-ui/icons/Delete";
import { Link, useNavigate } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import { CSVLink, CSVDownload } from "react-csv";
import GetAppIcon from "@material-ui/icons/GetApp";
import { useParams } from "react-router-dom";
import { fetchWithToken } from "../../../../apiUtils";

function descendingComparator(a, b, orderBy) {
  if (a[orderBy] === null) {
    return -1;
  } else if (b[orderBy] === null) {
    return 1;
  } else if (b[orderBy] < a[orderBy]) {
    return -1;
  } else if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator, domain) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "id", label: "ID", key: "id" },
  { id: "name", label: "Pool", key: "name" },
  { id: "startNumber", label: "Start", key: "startNumber" },
  { id: "endNumber", label: "End", key: "endNumber" },
  { id: "totalCount", label: "Total Count", key: "totalCount" },
  { id: "availableCount", label: "Available Count", key: "availableCount" },
  { id: "assigned", label: "Assigned", key: "assigned" },
  { id: "ownerTechnology", label: "Owner Technology", key: "ownerTechnology" },
  { id: "description", label: "Onboarding Status", key: "description" },
];

function RangesTableHead(props) {
  const { classes, order, orderBy, onRequestSort, getTotalAssigned } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell style={{ minWidth: "56px" }} />
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            padding="50px"
            style={{ fontSize: ".8vw", padding: "5px" }}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {(headCell.id == "id" ||
                headCell.id == "name" ||
                headCell.id == "startNumber" ||
                headCell.id == "endNumber" ||
                headCell.id == "totalCount" ||
                headCell.id == "availableCount" ||
                headCell.id == "ownerTechnology" ||
                headCell.id == "description") && (
                <div align="center" style={{ fontSize: ".9vw" }}>
                  {headCell.label}
                </div>
              )}
              {headCell.id == "assigned" && (
                <div align="center" style={{ fontSize: ".9vw" }}>
                  {headCell.label} {getTotalAssigned()}
                </div>
              )}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell
          align="center"
          padding="50px"
          style={{ fontSize: ".9vw", padding: "5px" }}
        >
          Endpoints
        </TableCell>
        <TableCell
          align="center"
          padding="50px"
          style={{ fontSize: ".9vw", padding: "5px" }}
        >
          Edit
        </TableCell>
        <TableCell
          align="center"
          padding="50px"
          style={{ fontSize: ".9vw", padding: "5px" }}
        >
          Delete
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

RangesTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
    margin: 40,
  },
  csvLink: {
    width: "500px",
  },
}));

const rangeHeaders = [
  { label: "RangeId", key: "rangeId" },
  { label: "Number", key: "number" },
  { label: "Status", key: "description" },
  { label: "GMID", key: "gmid" },
  { label: "Comments", key: "statusComment" },
  { label: "Display Name", key: "displayName" },
  { label: "Dial Plan", key: "dialPlan" },
  { label: "Voice Policy", key: "voicePolicy" },
];

const RangesTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { ranges } = props;

  var merged = [].concat.apply(
    [],
    ranges.map((r) => {
      return r.phoneNumbers;
    })
  );

  console.log(ranges);

  const phoneNumbers = merged.map((p) => {
    return Object.assign({
      rangeId: p.rangeId,
      number: `=""${p.did}""`,
      description: p.description,
      gmid: p.gmid,
      statusComment: p.statusComment,
      status: p.status,
      displayName: p.displayName,
      dialPlan: p.dialPlan,
      voicePolicy: p.voicePolicy,
    });
  });

  return (
    <Toolbar className={classes.root}>
      <Typography
        className={classes.title}
        variant="h5"
        id="tableTitle"
        component="div"
      >
        {ranges.length > 0 ? <>{ranges[0].name} Ranges</> : <>No Ranges</>}
      </Typography>
      {ranges.length > 0 && (
        <div style={{ width: "250px" }}>
          <CSVLink
            data={phoneNumbers}
            headers={rangeHeaders}
            filename={`DMV_${ranges[0].name}_AllRanges.csv`}
          >
            <GetAppIcon />
            All Range Data For Pool
          </CSVLink>
        </div>
      )}
    </Toolbar>
  );
};

RangesTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  smallColumn: {
    width: "10px",
  },
}));

export default function RangesByPoolTable(props) {
  const history = useNavigate();
  const { ranges, isAdmin } = props;
  const classes = useStyles();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [rows, setRows] = useState(ranges);
  var editable = isAdmin;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const handleDelete = (id) => {
    var successfulResponse = false;

    fetchWithToken(`api/Ranges/` + id, "DELETE")
      .then((res) => {
        console.log("res", res.ok);
        if (res.ok) {
          successfulResponse = true;
          let newRows = rows.filter((row) => row.id != id);
          setRows(newRows);
        }
        return res.json();
      })
      .then((data) => {
        console.log("successfulResponse", successfulResponse);
        sendAlert(data.returnMessage, successfulResponse ? "success" : "error");
        console.log("Data Returned: ", data.returnObject);
      });
  };

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });
  };

  const clearAlert = () => {
    setAlertMessage({
      message: "",
      varient: "",
      active: false,
    });
  };

  const getTotalAssigned = () => {
    var finalValue = 0;
    rows.map((r) => {
      finalValue += r.assigned;
    });
    return finalValue;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <>
      <div className={classes.root}>
        <Paper className={classes.paper}>
          {alertMessage.active && (
            <Alert severity={alertMessage.varient} onClose={() => clearAlert()}>
              {alertMessage.message}
            </Alert>
          )}
          <RangesTableToolbar ranges={ranges} />
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size="medium"
              aria-label="enhanced table"
            >
              <RangesTableHead
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
                getTotalAssigned={getTotalAssigned}
              />
              <TableBody>
                {stableSort(rows, getComparator(order, orderBy), orderBy)
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={row.id}
                        style={{
                          height: "80px",
                          background: index % 2 ? "#f8f8f8" : "white",
                        }}
                      >
                        <TableCell align="center">
                          <CSVLink
                            data={row.phoneNumbers.map((p) => {
                              return Object.assign({
                                rangeId: p.rangeId,
                                number: `=""${p.did}""`,
                                description: p.description,
                                gmid: p.gmid,
                                statusComment: p.statusComment,
                                status: p.status,
                                displayName: p.displayName,
                                dialPlan: p.dialPlan,
                                voicePolicy: p.voicePolicy,
                              });
                            })}
                            headers={rangeHeaders}
                            filename={`DMV_${row.name}_Range${row.id}.csv`}
                          >
                            <GetAppIcon />
                          </CSVLink>
                        </TableCell>
                        <TableCell align="center" style={{ width: "150px" }}>
                          {row.id}
                        </TableCell>
                        <TableCell align="left" style={{ width: "250px" }}>
                          {row.name}
                        </TableCell>
                        <TableCell align="left" style={{ width: "180px" }}>
                          {row.startNumber}
                        </TableCell>
                        <TableCell align="left" style={{ width: "180px" }}>
                          {row.endNumber}
                        </TableCell>
                        <TableCell align="center">{row.totalCount}</TableCell>
                        <TableCell align="center">
                          {row.availableCount}
                        </TableCell>
                        <TableCell align="center">{row.assigned}</TableCell>
                        <TableCell align="center">
                          {row.ownerTechnology}
                        </TableCell>
                        <TableCell align="center">{row.description}</TableCell>
                        <TableCell className={classes.smallColumn}>
                          <Link
                            to={`/phoneNumbers/byRange/${row.id}`}
                            style={{ textDecoration: "none" }}
                          >
                            <Button variant="contained" size="small">
                              <VisibilityIcon />
                            </Button>
                          </Link>
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => history(`/ranges/edit/${row.id}`)}
                            disabled={editable}
                          >
                            <EditIcon />
                          </Button>
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={(e) => {
                              if (
                                window.confirm(
                                  `Are you sure you wish to delete Range ${row.id}?`
                                )
                              )
                                handleDelete(row.id);
                            }}
                            disabled={editable}
                          >
                            <DeleteIcon />
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: rows.length > rowsPerPage ? 80 * emptyRows : 80,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 50, 100]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangeRowsPerPage={handleChangeRowsPerPage} // Material v < 4
            onRowsPerPageChange={handleChangeRowsPerPage} // Material v > 4
            onPageChange={handleChangePage} // Material v > 4
            onChangePage={handleChangePage} // Material v < 4
          />
        </Paper>
      </div>
    </>
  );
}
